import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { RouterEvent } from '@angular/router';
import { Address, EditOrganisationFields } from '../../organisation.model';
import { DropdownBankData } from '../../individual/edit/edit-individual.component';
import { RegisterOrganisationFields } from '../../../auth/registration/register-organization/register-organization.model';
import { OrganizationApiService } from '../../../../core/modules/organization/organization-api.service';
import { PersonWorkPosition } from '../../../../core/modules/organization/organization.types';

export interface DropdownPersonWorkPosition extends Array<PersonWorkPosition> {
  type?: 'position';
}

@UntilDestroy()
@Component({
  selector: 'tax-edit-legal',
  templateUrl: './edit-legal.component.html',
  styleUrls: ['./edit-legal.component.sass'],
})

export class EditLegalComponent implements OnInit {
  // @ts-ignore
  @Input() organization: EditOrganisationFields | RegisterOrganisationFields;
  @Input() isPasswordValid: boolean = true;
  @Input() isRegistration = false;

  @Output() goBack: EventEmitter<void> = new EventEmitter<void>();
  @Output() submitForm: EventEmitter<EditOrganisationFields | RegisterOrganisationFields> = new EventEmitter<EditOrganisationFields | RegisterOrganisationFields>();

  isEmailVerified = false;
  isSameAddress = true;
  positions: DropdownPersonWorkPosition = [];
  banks: DropdownBankData = [];

  constructor(
    private organizationApiService: OrganizationApiService,
  ) {}

  ngOnInit(): void {
    this.getPositions();
    this.getBanks();
    this.isSameAddress = JSON.stringify(this.organization.actualAddress) === JSON.stringify(this.organization.legalAddress);
  }

  toggleActualAddress(): void {
    this.isSameAddress = !this.isSameAddress;
    // @ts-ignore
    this.organization.actualAddress = this.isSameAddress
      ? this.organization.legalAddress
      : undefined;
  }

  emailVerifier(email: string): void {
    this.isEmailVerified = !!email;
    this.organization.email = email;
  }

  setLegalAddress(address: Address): void {
    this.organization.legalAddress = address;
    if (this.isSameAddress) {
      this.organization.actualAddress = this.organization.legalAddress;
    }
  }

  setActualAddress(address: Address): void {
    this.organization.actualAddress = address;
  }

  back(): void {
    this.goBack.emit();
  }

  selectedPosition(item: { id: number; name: string }): void {
    this.organization.generalManager.positionId = item.id.toString();
  }

  selectedBank(item: { id: string; name: string }): void {
    this.organization.bank = item.name;
    this.organization.bic = item.id;
  }

  isOrganizationFieldsValid(): boolean {
    // @ts-ignore
    return (this.organization
      && this.organization.legalAddress?.fullAddress
      && this.organization.actualAddress?.fullAddress
      && this.organization.email
      && this.organization.phone
    // @ts-ignore
      && this.organization.phone.match(/\d+/g)?.join('').length >= 11)
      && ((this.organization.paymentAccount && this.organization.paymentAccount.length === 0)
        || !this.isIikValid(this.organization.paymentAccount));
  }

  isFormValid(): boolean {
    if (this.isRegistration) {
      return (
        (this.organization as RegisterOrganisationFields).confirmOffer
        && this.isPasswordValid
        && this.isOrganizationFieldsValid()
      );
    }
    return this.isOrganizationFieldsValid();
  }

  iikChange(event: Event | RouterEvent): void {
    if (event instanceof RouterEvent) return;

    this.organization.paymentAccount = (event.target as HTMLInputElement).value;
  }

  isIikValid(iik: string | undefined): boolean {
    // @ts-ignore
    return iik && iik.length < 20;
  }

  onSubmit(): void {
    this.submitForm.emit(this.organization);
  }

  private getBanks(): void {
    this.organizationApiService.fetchBanks()
      .pipe(untilDestroyed(this))
      .subscribe((response) => {
        this.banks = response;
        this.banks.type = 'bank';
      });
  }

  private getPositions(): void {
    this.organizationApiService.fetchPositions()
      .pipe(untilDestroyed(this))
      .subscribe(
        (response) => {
          this.positions = response;
          this.positions.type = 'position';
        },
      );
  }
}
